import { render, staticRenderFns } from "./LegoParam.vue?vue&type=template&id=272509ab&scoped=true&"
import script from "./LegoParam.vue?vue&type=script&lang=ts&"
export * from "./LegoParam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272509ab",
  null
  
)

export default component.exports